var exports = {
  "Sc": "Checkbox___uffeh",
  "az": "Box__kITTXA",
  "wy": "Box_1__RV0G42",
  "pv": "Box_2__yJdJpE",
  "EY": "Text__KNqBMf",
  "UE": "Text_1__EEE4Qm",
  "N_": "Link__3ScOr8",
};

module.exports = exports;
